import { Card, Skeleton } from '@/shared/components';

const SkeletonItem = () => (
  <div className="w-full flex items-center justify-between py-[1.4rem]  px-0 md:px-[1.6rem]">
    <div className="flex items-center gap-[1.4rem]">
      <Skeleton variant="avatar" className="w-[4.4rem]" />

      <div className="flex flex-col gap-[1rem]">
        <Skeleton variant="small" className="w-[8rem] h-[1.6rem]" />
        <Skeleton variant="small" className="w-[5.3rem] h-[1.2rem]" />
      </div>
    </div>
    <div className="flex items-center justify-center">
      <Skeleton variant="medium" className="w-[7rem]" />
    </div>
  </div>
);

export const HistoryOperationsListSkeleton = () => {
  return (
    <Card className="w-full py-[1.6rem] px-[1.2rem] flex flex-col rounded-[2.4rem] gap-0">
      {Array.from({ length: 10 }).map((_, index) => (
        <SkeletonItem key={index} />
      ))}
    </Card>
  );
};
